// src/customer-form/types.js

export const INITIAL_STATE = {
  country: 'Kenya',
  contactName: '',
  caseType: 'Complaint',
  caseReason: 'CMP- AMC Issue',
  subReason: '',
  escalationPath: '',
  unitResponsible: '',
  issueType: 'Vehicle issues/Faulty car',
  email: '',
  phone: '',
  location: '',
  make: '',
  model: '',
  carReg: '',
  documentType: '',
  subject: '',
  description: '',
  attachments: [],
  hpWebsite: '',
};
